import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'hyperlink-renderer',
	template: `<a [routerLink]="this.link" [queryParams]="this.queryParams" [title]="this.displayValue">{{ this.displayValue }}</a>`,
	styles: [
		`
			a:visited {
				color: #0000ee;
			}
		`,
	],
	imports: [RouterModule],
})
export class HyperlinkCellRenderer implements AgRendererComponent {
	public displayValue: any = undefined;
	public link: any = undefined;
	public queryParams: any = undefined;

	constructor(private router: Router) {}

	agInit(params: ICellRendererParams): void {
		if (params.value) {
			this.displayValue = params.value.displayName;
			this.link = params.value.link;
			this.queryParams = params.value.queryParams;
		}
	}

	refresh(params: ICellRendererParams): boolean {
		if (params.value) {
			this.displayValue = params.value.displayName;
			this.link = params.value.link;
			this.queryParams = params.value.queryParams;
			return true;
		}
		return false;
	}

	navigate() {
		this.router.navigate([this.link]);
	}
}
